<template>
    <b-modal ref="mdlNuovaAnagrafica" size="xl" :title="titoloModal" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div>
            <b-card class="sa-card" header="Testata" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Numero:</label>
                        <!-- <b-form-input v-model="jsonData.anagrafica.nominativo"></b-form-input> -->
                        <span class="sa-data">{{ jsonData.numero }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Descrizione:</label>
                        <!-- <b-form-input v-model="jsonData.anagrafica.nominativo"></b-form-input> -->
                        <span class="sa-data">{{ jsonData.descrizioneAnagrafica }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note:</label>
                        <!-- <b-form-input v-model="jsonData.anagrafica.nominativo"></b-form-input> -->
                        <span class="sa-data">{{ jsonData.noteAnagrafica }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice Intestatario:</label>
                        <!-- <b-form-input v-model="jsonData.anagrafica.nominativo"></b-form-input> -->
                        <span class="sa-data">{{ jsonData.anagrafica.codice }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Nominativo Intestatario:</label>
                        <span class="sa-data">{{ jsonData.anagrafica.nominativo }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice Fiscale:</label>
                        <span class="sa-data">{{ jsonData.anagrafica.codiceFiscale }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">P. Iva:</label>
                        <span class="sa-data">{{ jsonData.anagrafica.partitaIva }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Citta:</label>
                        <span class="sa-data">{{ jsonData.anagrafica.citta }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Indirizzo:</label>
                        <span class="sa-data">{{ jsonData.anagrafica.indirizzo }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">N. Documento Origine:</label>
                        <span class="sa-data">{{ jsonData.documentoOrigine }}</span>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <b-form-checkbox v-if="!nuovo" v-model="jsonData.attivo" name="check-button" switch>
                            <label class="sa-label-data">Attivo</label>
                        </b-form-checkbox>
                    </b-col>
                </b-row> -->
            </b-card>
            <b-card class="sa-card" header="Righe" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaRighe" :fields="fields" :current-page="1" :per-page="1000000000" sort-icon-left head-variant="light">
                            <template #cell(index)="row">
                                {{ row.index + 1 }}
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card" header="Totali" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Importo Lordo:</label>
                        <span class="sa-data">{{ jsonData.importoLordo }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Importo Netto:</label>
                        <span class="sa-data">{{ jsonData.importoNetto }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Importo Iva:</label>
                        <span class="sa-data">{{ jsonData.importoIva }}</span>
                    </b-col>
                </b-row>
            </b-card>
            <modal-error ref="cmpModalError"></modal-error>
        </div>
    </b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
// import DatePicker from "vue2-datepicker";
export default {
    components: { ModalError },
    mixins: [UtilityMixin],
    // components: { DatePicker },
    data() {
        return {
            isNew: true,
            isReadonly: false,
            isRequired: false,
            pathResource: "/documenti",
            pathFornitori: "/anagrafica",
            pathIva: "/iva",
            pathGruppi: "/articoligruppi",
            pathArticoli: "/articoli",
            pathMarche: "/marche",
            pathUnitaMisura: "/unitamisura",
            pathDepositi: "/depositi",
            pathResourceTipiAnagrafica: "/dizionariotipi",
            nuovo: false,
            titoloModal: "",
            fornitoriOptions: [],
            ivaOptions: [],
            gruppiOptions: [],
            marcheOptions: [],
            unitaMisuraOptions: [],
            depositiOptions: [],
            nomeDocumento: "",
            tipoAnagraficaOptions: [],
            articoliOptions: [],
            jsonData: {
                tipo: "",
                dataOra: null,
                importoNetto: 0,
                importoNettoAggiuntivo: 0,
                importoIva: 0,
                importoLordo: 0,
                statoAttuale: "",
                statoAttualeDataOra: null,
                idAnagrafica: "",
                listaRighe: [],
                anagrafica: { codice: null, nominativo: null, codiceTipo: null, indirizzo: null, citta: null, telefono: null, partitaIva: null, codiceFiscale: null, attivo: true, listaNote: [] },
            },
            siNoOption: [
                { value: "", text: "-Seleziona Valore-" },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Descrizione",
                    key: "descrizioneArticolo",
                    // thStyle: "width: 20rem",
                    // sortable: true,
                },
                {
                    label: "Quantià",
                    key: "quantita",
                    thStyle: "width: 15rem",
                    // sortable: true,
                },
                {
                    label: "Prezzo Unitario",
                    key: "prezzoUnitario",
                    thStyle: "width: 15rem",
                    // sortable: true,
                },
                {
                    label: "Descrizione Aliquota Iva",
                    key: "aliquotaIvaDescrizione",
                    // thStyle: "width: 15rem",
                    // sortable: true,
                },
                {
                    label: "Aliquota Iva",
                    key: "aliquotaIva",
                    thStyle: "width: 15rem",
                    // sortable: true,
                },
                {
                    label: "Offerta",
                    key: "offerta",
                    thStyle: "width: 15rem",
                    // sortable: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "", thStyle: "width: 5rem" },
            ],
        };
    },
    methods: {
        openModal(item, documento) {
            let me = this;
            me.nomeDocumento = documento;
            let codice = this.$route.query.codiceTipo;
            me.$emit("beforloadData");
            if (item !== null) {
                me.nuovo = false;
                me.titoloModal = "Visualizza Documento " + me.nomeDocumento;
                // me.jsonData = item;
                me.loadData(item.id);
            } else {
                me.nuovo = true;
                me.titoloModal = "Aggiungi Documento";
                me.jsonData = {
                    tipo: codice,
                    dataOra: null,
                    importoNetto: 0,
                    importoNettoAggiuntivo: 0,
                    importoIva: 0,
                    importoLordo: 0,
                    statoAttuale: "",
                    statoAttualeDataOra: null,
                    idAnagrafica: "",
                    listaRighe: [],
                    anagrafica: { codice: null, nominativo: null, codiceTipo: null, indirizzo: null, citta: null, telefono: null, partitaIva: null, codiceFiscale: null, attivo: true, listaNote: [] },
                };
                // me.jsonData.listaRighe.push({ aliquotaIva: 0, descrizioneArticolo: "", idArticolo: "", offerta: "", prezzoUnitario: 0, quantita: 0 });
            }
            me.loadFornitori();
            me.loadArticoli();
            me.loadIva();
            me.loadGruppi();
            me.loadMarche();
            me.loadUnitaMisura();
            me.loadDepositi();
            me.$refs.mdlNuovaAnagrafica.show();
            me.$emit("afterLoadData");
        },
        loadData(id) {
            let me = this;
            let tipo = this.$route.query.tipo;
            let path = "";
            if (tipo === "A") {
                path = me.pathResource + "/a";
            } else {
                path = me.pathResource;
            }
            let link = process.env.VUE_APP_PATH_API + path + "/" + id;
            UtilityMixin.methods.restCallGet(link, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.$emit("afterLoadData");
            // me.jsonData.listaRighe.push({ aliquotaIva: 0, descrizioneArticolo: "", idArticolo: "", offerta: "", prezzoUnitario: 0, quantita: 0 });
        },
        loadDataError(response) {
            console.log(response);
            this.$emit("afterLoadData");
        },
        loadTipiAnagrafica() {
            let me = this;
            let filtro = {};
            filtro.sezioneDizionario = "ANAGRAFICA";
            UtilityMixin.methods.loadDataResources(me.pathResourceTipiAnagrafica, filtro, me.loadTipiAnagraficaSuccess, me.loadTipiAnagraficaError);
        },
        loadTipiAnagraficaSuccess(response) {
            let me = this;
            me.tipoAnagraficaOptions = response.data.data.list;
            me.tipoAnagraficaOptions.unshift({ codice: null, nominativo: "-Seleziona Valore-" });
        },
        loadTipiAnagraficaError(response) {
            console.log(response);
        },
        loadFornitori() {
            let me = this;
            let filtro = { codiceTipo: "ALL" };
            UtilityMixin.methods.loadDataResources(me.pathFornitori, filtro, me.loadFornitoriSuccess, me.loadFornitoriError);
        },
        loadFornitoriSuccess(response) {
            let me = this;
            me.fornitoriOptions = response.data.data.list;
            me.fornitoriOptions.unshift({ codice: null, nominativo: "-Seleziona Valore-" });
        },
        loadFornitoriError(response) {
            console.log(response);
        },
        loadArticoli() {
            let me = this;
            let filtro = {};
            UtilityMixin.methods.loadDataResources(me.pathArticoli, filtro, me.loadArticoliSuccess, me.loadArticoliError);
        },
        loadArticoliSuccess(response) {
            let me = this;
            me.articoliOptions = response.data.data.list;
            me.articoliOptions.unshift({ codice: "", descrizione: "-Seleziona Valore-" });
        },
        loadArticoliError(response) {
            console.log(response);
        },
        loadIva() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathIva, null, me.loadIvaSuccess, me.loadIvaError);
        },
        loadIvaSuccess(response) {
            let me = this;
            me.ivaOptions = response.data.data.list;
            me.ivaOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        loadIvaError(response) {
            console.log(response);
        },
        loadGruppi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathGruppi, null, me.loadGruppiSuccess, me.loadGruppiError);
        },
        loadGruppiSuccess(response) {
            let me = this;
            me.gruppiOptions = response.data.data.list;
            me.gruppiOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        loadGruppiError(response) {
            console.log(response);
        },
        loadMarche() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathMarche, null, me.loadMarcheSuccess, me.loadMarcheError);
        },
        loadMarcheSuccess(response) {
            let me = this;
            me.marcheOptions = [];
            response.data.data.list.forEach((element) => {
                me.marcheOptions.push({ value: element.descrizone, text: element.descrizone });
            }),
                me.marcheOptions.unshift({ value: null, text: "-Seleziona Valore-" });
        },
        loadMarcheError(response) {
            console.log(response);
        },
        loadUnitaMisura() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathUnitaMisura, null, me.loadUnitaMisuraSuccess, me.loadUnitaMisuraError);
        },
        loadUnitaMisuraSuccess(response) {
            let me = this;
            me.unitaMisuraOptions = response.data.data.list;
            me.unitaMisuraOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        loadUnitaMisuraError(response) {
            console.log(response);
        },
        loadDepositi() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathDepositi, null, me.loadDepositiSuccess, me.loadDepositiError);
        },
        loadDepositiSuccess(response) {
            let me = this;
            me.depositiOptions = response.data.data.list;
            me.depositiOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        loadDepositiError(response) {
            console.log(response);
        },
        onCloseModal() {
            let me = this;
            me.$emit("beforloadData");
            me.jsonData = {
                tipo: null,
                dataOra: null,
                importoNetto: 0,
                importoNettoAggiuntivo: 0,
                importoIva: 0,
                importoLordo: 0,
                statoAttuale: "",
                statoAttualeDataOra: null,
                idAnagrafica: "",
                listaRighe: [],
            };
            me.$emit("afterLoadData");
        },
        onClickOk(bvModalEvent) {
            let me = this;
            me.$emit("beforloadData");
            bvModalEvent.preventDefault();
            // console.log(me.jsonData);
            me.jsonData.statoAttuale = "COMPLETA";
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, this.saveSuccessResponse, this.saveErrorResponse);
        },
        onClickSalvaBozza(bvModalEvent) {
            let me = this;
            me.$emit("beforloadData");
            bvModalEvent.preventDefault();
            // console.log(me.jsonData);
            me.jsonData.statoAttuale = "BOZZA";
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, this.saveSuccessResponse, this.saveErrorResponse);
        },
        saveSuccessResponse(response) {
            let me = this;
            me.$emit("afterSaveSuccess", response);
            me.$emit("afterLoadData");
            me.$refs.mdlNuovaAnagrafica.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },

        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
            this.$emit("afterLoadData");
        },
        onChangeFornitore() {
            let me = this;
            me.fornitoriOptions.forEach((element) => {
                if (element.codice === me.jsonData.anagrafica.codice) {
                    me.jsonData.anagrafica = element;
                    me.jsonData.idAnagrafica = element.id;
                }
            });
        },
        onChangeArticolo(item) {
            let me = this;
            me.articoliOptions.forEach((element) => {
                if (element.descrizione === item.descrizioneArticolo) {
                    item.idArticolo = element.id;
                    item.aliquotaIva = element.aliquotaIva;
                }
            });
        },
        onChangeIva() {
            let me = this;
            me.ivaOptions.forEach((element) => {
                if (element.codice === me.jsonData.codiceIva) {
                    me.jsonData.descrizioneIva = element.descrizione;
                    me.jsonData.aliquotaIva = element.aliquota;
                }
            });
        },
        onAdd(array, value) {
            if (value.descrizioneArticolo) {
                array.push({ aliquotaIva: 0, descrizioneArticolo: "", idArticolo: "", offerta: "", prezzoUnitario: 0, quantita: 0 });
            } else {
                this.$bvModal
                    .msgBoxOk("Il campo Codice e' OBBLIGATORIO", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    })
                    .then(() => {
                        // console.log(value);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        onDelete(array, row) {
            if (row.index != array.length) {
                this.$bvModal
                    .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                        title: "Titolo",
                        buttonSize: "sm",
                        okVariant: "secondary",
                        cancelVariant: "danger",
                        okTitle: "SI",
                        cancelTitle: "NO",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            array.splice(row.index, 1);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        onClose() {
            let me = this;
            me.$refs.mdlNuovaAnagrafica.hide();
            me.jsonData = {
                tipo: null,
                dataOra: null,
                importoNetto: 0,
                importoNettoAggiuntivo: 0,
                importoIva: 0,
                importoLordo: 0,
                statoAttuale: "",
                statoAttualeDataOra: null,
                idAnagrafica: "",
                listaRighe: [],
                anagrafica: { codice: null, nominativo: null, codiceTipo: null, indirizzo: null, citta: null, telefono: null, partitaIva: null, codiceFiscale: null, attivo: true, listaNote: [] },
            };
        },
    },
};
</script>
<style scoped>
.btn-outline-warning {
    color: #ff6a07;
    border-color: #ff6a07;
}

.btn-outline-warning:hover {
    color: #fff;
    background-color: #ff6a07;
    border-color: #ff6a07;
}

.btn-outline-warning.focus,
.btn-outline-warning:focus {
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.5);
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
    color: #ff6a07;
    background-color: transparent;
}

.btn-outline-warning:not(:disabled):not(.disabled).active,
.btn-outline-warning:not(:disabled):not(.disabled):active,
.show > .btn-outline-warning.dropdown-toggle {
    color: #1f2d3d;
    background-color: #ff6a07;
    border-color: #ff6a07;
}

.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.btn-outline-warning:not(:disabled):not(.disabled):active:focus,
.show > .btn-outline-warning.dropdown-toggle:focus {
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.5);
}
</style>
